var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "contract-after-info" }, [
    _c("h3", [_vm._v("改补描述")]),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "loading",
            rawName: "v-loading",
            value: _vm.loading,
            expression: "loading",
          },
        ],
      },
      [
        _vm.afterInfoList.length > 0
          ? _c(
              "div",
              [
                _c(
                  "el-table",
                  {
                    staticStyle: { width: "100%", "font-size": "13px" },
                    attrs: {
                      data: _vm.afterInfoList,
                      size: "small",
                      border: "",
                      "header-cell-style": {
                        backgroundColor: "#e8eaed",
                        color: "#333",
                        fontWeight: "bold",
                      },
                    },
                  },
                  [
                    _c("el-table-column", {
                      attrs: {
                        type: "index",
                        label: "序号",
                        width: "60",
                        align: "center",
                      },
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "questionType",
                        label: "问题类型",
                        "min-width": "120",
                      },
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "serverUserName",
                        label: "客服用户名",
                        "min-width": "120",
                      },
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "serverNickName",
                        label: "客服昵称",
                        "min-width": "120",
                      },
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "problemDescription",
                        label: "问题描述",
                        "min-width": "200",
                      },
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { label: "附件", "min-width": "120" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                scope.row.file
                                  ? _c(
                                      "div",
                                      _vm._l(
                                        _vm.getFileList(scope.row.file),
                                        function (f, idx) {
                                          return _c(
                                            "a",
                                            {
                                              key: idx,
                                              staticStyle: {
                                                display: "block",
                                                color: "#409EFF",
                                              },
                                              attrs: {
                                                href: _vm.getFileUrl(f),
                                                target: "_blank",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                " +
                                                  _vm._s(
                                                    f.localName || f.realName
                                                  ) +
                                                  "\n              "
                                              ),
                                            ]
                                          )
                                        }
                                      ),
                                      0
                                    )
                                  : _c("span", [_vm._v("-")]),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        1047269093
                      ),
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { label: "图片", "min-width": "120" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                scope.row.image
                                  ? _c(
                                      "div",
                                      { staticClass: "image-list" },
                                      _vm._l(
                                        _vm.getFileList(scope.row.image),
                                        function (img, idx) {
                                          return _c("el-image", {
                                            key: idx,
                                            staticStyle: {
                                              width: "60px",
                                              height: "60px",
                                              "margin-right": "4px",
                                            },
                                            attrs: {
                                              src: _vm.getFileUrl(img),
                                              "preview-src-list":
                                                _vm.getPreviewList(
                                                  scope.row.image
                                                ),
                                              "initial-index": idx,
                                              fit: "cover",
                                            },
                                          })
                                        }
                                      ),
                                      1
                                    )
                                  : _c("span", [_vm._v("-")]),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        1494758726
                      ),
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { label: "视频", "min-width": "120" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                scope.row.video
                                  ? _c(
                                      "div",
                                      { staticClass: "video-list" },
                                      _vm._l(
                                        _vm.getFileList(scope.row.video),
                                        function (v, idx) {
                                          return _c(
                                            "video",
                                            {
                                              key: idx,
                                              staticStyle: {
                                                width: "100px",
                                                height: "60px",
                                                background: "#000",
                                                "margin-right": "4px",
                                              },
                                              attrs: {
                                                src: _vm.getFileUrl(v),
                                                controls: "",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                您的浏览器不支持视频播放\n              "
                                              ),
                                            ]
                                          )
                                        }
                                      ),
                                      0
                                    )
                                  : _c("span", [_vm._v("-")]),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        904990417
                      ),
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "createTime",
                        label: "创建时间",
                        "min-width": "160",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            )
          : _c(
              "div",
              { staticClass: "no-data" },
              [_c("el-empty", { attrs: { description: "暂无改补记录" } })],
              1
            ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }